'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FETCH_THREAD_HISTORY = exports.FETCH_THREAD_HISTORY = 'FETCH_THREAD_HISTORY';


//////////////////
// WEBPACK FOOTER
// ./js/thread-histories/constants/ActionTypes.js
// module id = 196
// module chunks = 2 3